import Table from '@/src/components/Antd/Table/SizeFittingTable';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import { get } from 'lodash';
import React from 'react';
import { useHistory, useParams } from 'react-router';
import Tooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import { useI18n } from 'src/hooks/useRouterChange';
import Actions from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/Components/TableActions';
import { isNumber } from 'src/tools/helper';
import { i18nGet } from 'src/tools/tools';
import { EnumTablePosition } from 'src/types/common/common';
import css from './table.module.less';
import { useSalesChannel } from 'src/constrains/SalesChannelHOC/useSalesChannel';

const SubTable = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { data } = props;
  const { saleChannelUuid }: any = useParams();
  const sc = useSalesChannel();
  const decimalPosition = get(sc, 'decimalPosition');
  const h = useHistory();
  const { alias, salesChannelProduct, products, currency } = data || {};
  const { name, uuid } = salesChannelProduct || {};
  const col = [
    {
      minWidth: 320,
      title: getI18n('general.storeCommunicationSetting.product'),
      key: 'Product',
      default: true,
      //className: css.firstCol,
      propsGenerate: (a, record, index) => {
        const rowSpan = get(record, 'rowSpan');
        return { rowSpan };
      },
      childGenerate: (a, record, index) => {
        const productName = get(record, 'productName');
        const sku = get(record, 'sku');
        const title = `${sku || ''} ${productName || ''}`;
        return (
          <NoWrapContainer>
            <Tooltip title={title}>{title}</Tooltip>
          </NoWrapContainer>
        );
      },
    },
    {
      minWidth: 120,
      title: getI18n('salesChannelProductDetail.index.subscriptionBuyTitle'),
      key: 'title',
      className: css.firstCol,
      default: true,
      propsGenerate: (a, record, index) => {
        const rowSpan = get(record, 'rowSpan');
        return { rowSpan };
      },
      childGenerate: (a, record, index) => {
        const name = get(record, 'title');
        return (
          <NoWrapContainer>
            <Tooltip title={name}>{name}</Tooltip>
          </NoWrapContainer>
        );
      },
    },
    {
      titleGenerate: () => getI18n('general.frequency'),
      //   position: EnumTablePosition.mid,
      key: 'Frequency',
      default: true,
      childGenerate: (url, record, index) => {
        const frequency = get(record, 'frequency');
        const frequencyUnit = get(record, 'frequencyUnit');
        const name =
          frequency && frequencyUnit
            ? `Every ${frequency} ${frequencyUnit}`
            : '-';
        return (
          <NoWrapContainer>
            <Tooltip title={name}>{name}</Tooltip>
          </NoWrapContainer>
        );
      },
      width: 112,
    },

    {
      titleGenerate: () =>
        `${getI18n(
          'salesChannelProductDetail.index.subscriptionBuyPrice',
        )} (${currency})`,
      position: EnumTablePosition.right,
      key: 'price',
      default: true,
      childGenerate: (url, record, index) => {
        const _price = get(record, 'subscriptionPrice');
        const price =
          isNumber(_price) && isNumber(decimalPosition)
            ? _price.toFixed(decimalPosition)
            : '-';
        return (
          <NoWrapContainer>
            <Tooltip title={price}>{price}</Tooltip>
          </NoWrapContainer>
        );
      },
      width: 240,
    },
    {
      titleGenerate: () =>
        getI18n('general.advancedFilters.commonStoreProductsWithTable.actions'),
      position: EnumTablePosition.mid,
      key: 'Action',
      default: true,
      childGenerate: (url, record, index) => {
        //  console.log(record);
        const { subscriptionBuyUuid } = record;
        // const _price = get(record, 'price');
        // const price = isNumber(_price) ? _price.toFixed(2) : '-';
        return (
          <Actions
            onEdit={() => {
              h.push(
                `/salesChannel/discounts/subscriptionBuy/editor/${saleChannelUuid}/${subscriptionBuyUuid}`,
              );
            }}
          />
        );
      },
      width: 120,
    },
  ];
  return (
    <Section className={css.container}>
      <div className={css.title}>
        {alias ? getI18n('general.alias') : ''} {name || ''}
      </div>
      <Table
        rowKey={(record) => {
          const { uuid, frequency, frequencyUnit, price } = record;
          return `${uuid}-${frequency}-${frequencyUnit}-${price}`;
        }}
        pagination={false}
        dataSource={products || []}
        id={`${uuid}SalesChannelSubscriptionBuyTable`}
        columns={col}
      />
    </Section>
  );
};
export default SubTable;
